import { render, staticRenderFns } from "./SimilarItem.vue?vue&type=template&id=c0f78d5e&scoped=true&"
import script from "./SimilarItem.vue?vue&type=script&lang=js&"
export * from "./SimilarItem.vue?vue&type=script&lang=js&"
import style0 from "./SimilarItem.vue?vue&type=style&index=0&id=c0f78d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f78d5e",
  null
  
)

export default component.exports